import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome, faChevronLeft, faChevronRight, faUsers, faBuilding, faCubes, faUserShield,faUserCircle,
  faFileContract, faProjectDiagram, faTasks,faUserClock, faTachometerAlt,  faBoxes, faMoneyCheckDollar,faCloudUploadAlt,faFileInvoiceDollar,
  faCar, faShieldAlt, faUserCheck, faMoneyBillWave, faCalculator, faChartBar,faUserFriends,faClipboardList,faListCheck,faSignal
} from "@fortawesome/free-solid-svg-icons";
 
import { faUpload } from "@fortawesome/free-solid-svg-icons/faUpload";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faBell } from "@fortawesome/free-solid-svg-icons/faBell";
import { faClock } from "@fortawesome/free-solid-svg-icons/faClock";
 
import { faReceipt } from "@fortawesome/free-solid-svg-icons/faReceipt";
import { useAuth } from "./../context/AuthContext";
import { MODULES } from "../constants/globalConstants";

const SidePanel: React.FC = () => {
  const [isOpen, setIsOpen] = useState(true);
  const { user } = useAuth();

  const togglePanel = () => setIsOpen(!isOpen);

  const hasAccess = (moduleName: string) => {
    return user?.permissions?.some(
      (p) => p.moduleName.toLowerCase() === moduleName.toLowerCase() && p.visibleInSidebar
    );
  };

  const menuItems = [
    // Common Modules
    { path: "/", label: "Home", icon: faHome, module: MODULES.HOME },
    { path: "/user-home", label: "User Home", icon: faTachometerAlt, module: MODULES.USER_HOME },
    { path: "/user-profile", label: "Profile", icon: faUser , module: MODULES.USER_PROFILE },
    { path: "/about", label: "About", icon: faUsers, module: MODULES.ABOUT },
    { path: "/barqlytics", label: "Barqlytics", icon: faSignal , module: MODULES.BARQLYTICS },

    //Admin Modules
  
    { path: "/admin/tenants", label: "Tenants", icon: faBuilding, module: MODULES.TENANTS },
    { path: "/admin/users", label: "Users", icon: faUserFriends, module: MODULES.USERS },
    { path: "/admin/modules", label: "Modules", icon: faCubes, module: MODULES.MODULES },
    { path: "/admin/roles", label: "Roles", icon: faUserShield, module: MODULES.ROLES },

    //Tenant Modules
    { path: "/contracts", label: "Contracts", icon: faFileContract, module: MODULES.CONTRACTS },
    { path: "/projects", label: "Projects", icon: faProjectDiagram, module: MODULES.PROJECTS },
    { path: "/project-tasks", label: "Project Tasks", icon: faClipboardList, module: MODULES.PROJECT_TASKS },  // 🔄 Updated
    { path: "/general-tasks", label: "General Task", icon: faListCheck, module: MODULES.GENERAL_TASKS }, // 🔄 Updated
    { path: "/task-assignments", label: "Task Assignments", icon: faUserClock, module: MODULES.TASK_ASSIGNMENTS }, // 🔄 Updated

    
   // { path: "/uploads", label: "Uploads", icon: faCloudUploadAlt, module: MODULES.UPLOADS },
   
    { path: "/notifications", label: "Notifications", icon: faBell, module: MODULES.NOTIFICATION },
    { path: "/reminders", label: "Reminders", icon: faClock, module: MODULES.REMINDERS },
    { path: "/inventories", label: "Inventories", icon: faBoxes, module: MODULES.INVENTORIES },
    { path: "/payroll", label: "Payroll", icon: faMoneyCheckDollar, module: MODULES.PAYROLL },
    { path: "/vms", label: "VMS", icon: faCar, module: MODULES.VEHICLES },
    { path: "/vehicle-insurance", label: "Vehicle Insurance", icon: faShieldAlt, module: MODULES.VEHICLE_INSURANCE },
    { path: "/attendance", label: "Attendance", icon: faUserCheck, module: MODULES.ATTENDANCE },
    { path: "/payments", label: "Payments", icon: faMoneyBillWave, module: MODULES.PAYMENTS },
    { path: "/estimations", label: "Estimations", icon: faCalculator, module: MODULES.ESTIMATIONS },
    { path: "/reports", label: "Reports", icon: faChartBar, module: MODULES.REPORTS },
    { path: "/gst", label: "GST", icon: faFileInvoiceDollar, module: MODULES.GST },
  ];

  return (
    <div className={`flex flex-col ${isOpen ? "w-72" : "w-20"} h-full overflow-y-auto bg-gray-900 transition-all duration-300`}>
      <button onClick={togglePanel} className="bg-gray-700 text-white p-2">
        <FontAwesomeIcon icon={isOpen ? faChevronLeft : faChevronRight} />
      </button>

      <div className={`flex flex-col ${isOpen ? "block" : "hidden"} mt-4 space-y-4`}>
        {menuItems.map((item) => {
          if (!item.module || hasAccess(item.module)) {
            return (
              <Link key={item.path} to={item.path} className="text-white px-4 py-2 hover:bg-gray-600">
                <FontAwesomeIcon icon={item.icon} className="mr-2" />
                <span>{item.label}</span>
              </Link>
            );
          }
          return null;
        })}
      </div>

      {!isOpen && (
        <div className="flex flex-col items-center mt-4 space-y-4 text-white">
          {menuItems.map((item) => {
            if (!item.module || hasAccess(item.module)) {
              return (
                <Link key={item.path} to={item.path}>
                  <FontAwesomeIcon icon={item.icon} />
                </Link>
              );
            }
            return null;
          })}
        </div>
      )}

      <button onClick={togglePanel} className="bg-gray-700 text-white p-2">
        <FontAwesomeIcon icon={isOpen ? faChevronLeft : faChevronRight} />
      </button>
    </div>
  );
};

export default SidePanel;
